import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Household appliances 103",
  "use": "icon-Household appliances 103-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-Household appliances 103\"><path d=\"M832 832a64 64 0 0 1-64 64H256a64 64 0 0 1-64-64V192a64 64 0 0 1 64-64h512a64 64 0 0 1 64 64v640z m-64-320H256v320h512V512z m-384 64v170.666667h-64v-170.666667h64zM768 192H256v256h512V192z m-384 64v128h-64v-128h64z\" p-id=\"11567\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol